/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AltaMedicoModelDto } from '../../models/alta-medico-model-dto';

export interface MedicosControllerAltaMedico$Params {
  
    /**
     * Datos del médico a crear
     */
    body: AltaMedicoModelDto
}

export function medicosControllerAltaMedico(http: HttpClient, rootUrl: string, params: MedicosControllerAltaMedico$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, medicosControllerAltaMedico.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

medicosControllerAltaMedico.PATH = '/api/medicos/alta-medico';
